import { PencilIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedMatterClientUpdatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDiffList,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface MatterClientUpdatedEventProps {
  event: DiscriminatedMatterClientUpdatedEvent;
}

export const MatterClientUpdatedEvent: React.FC<
  MatterClientUpdatedEventProps
> = ({ event }) => {
  const { matter_client, diff } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-indigo-100">
          <PencilIcon className="h-4 w-4 text-indigo-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      {matter_client?.name && (
        <ActivityTitle>{matter_client.name}</ActivityTitle>
      )}
      {diff && <ActivityDiffList diff={diff} defaultExpanded={false} />}
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Client Updated"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
